export const PROCESS_CHANGED = 'BACKEND_PROCESS_CHANGED'
export const SETTINGS_CHANGED = 'BACKEND_SETTINGS_CHANGED'
export const LOCALE_CHANGED = 'BACKEND_SETTINGS_LOCALE_CHANGED'
export const SERVER_PROFILES_CHANGED = 'BACKEND_SERVER_PROFILES_CHANGED'
export const ACTIVE_SERVER_CHANGED = 'BACKEND_ACTIVE_SERVER_CHANGED'
export const SERVERLIST_CHANGED = 'BACKEND_SERVERLIST_CHANGED'



// WEBPACK FOOTER //
// ./src/features/Backend/data/constants.js